import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { BlackbaudRaisersEdgeIntegration, IBlackbaudFund } from '@feathr/blackbox';
import type { ISelectOption } from '@feathr/components';
import { Select } from '@feathr/components';

import useGetBBFunds from './useGetBBFunds';

interface IProps {
  helpText?: string;
  integration: BlackbaudRaisersEdgeIntegration;
  label?: string;
  onChange: (fund: IBlackbaudFund | undefined) => void;
  value?: string;
}

function BBFundSelect({
  helpText,
  integration,
  label,
  onChange,
  value,
}: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();
  const { funds, isLoading } = useGetBBFunds(integration);

  const options: ISelectOption[] = funds.map((fund) => ({
    id: fund.id,
    name: fund.description,
  }));

  function handleChange(option: ISelectOption): void {
    const selectedFund = funds.find((fund) => fund.id === option.id);
    onChange(selectedFund);
  }

  return (
    <Select
      helpText={helpText}
      id={'bb-fund-select'}
      isLoading={isLoading}
      isMulti={false}
      label={label}
      name={'bb-fund-select'}
      noOptionsMessage={t('No funds found')}
      onSelectSingle={handleChange}
      options={options}
      placeholder={t('Select a fund')}
      value={options.find((option) => option.id === value)}
    />
  );
}

export default BBFundSelect;
